// extracted by mini-css-extract-plugin
export default {"wrap":"benefit_wrap__bOd54","title":"benefit_title__pwGO8"};